import React from 'react';
import HwzComponent from '../../common/component/HwzComponent';
import { RouteComponentProps } from 'react-router-dom';
import Pager from '../../common/model/base/Pager';
import Space, { SpaceFormValues } from '../../common/model/space/Space';
import Matter from '../../common/model/matter/Matter';
import {
  Button,
  Card,
  Col,
  Dropdown,
  Menu,
  Pagination,
  Progress,
  Row,
  Space as AntdSpace,
  Modal,
  Empty,
  TreeSelect,
  Table,
  message,
  Tag,
  Alert,
  Badge,
  Upload,
  Input
} from 'antd';
import './List.less';
import Lang from '../../common/model/global/Lang';
import ModalForm from './widget/ModalForm';
import HwzTitle from '../widget/HwzTitle';
import MessageBoxUtil from '../../common/util/MessageBoxUtil';
import {
  AppstoreOutlined,
  BarsOutlined,
  EditOutlined,
  ExclamationCircleFilled,
  TeamOutlined,
  MoreOutlined,
  ApartmentOutlined,
  UsergroupAddOutlined,
  FolderAddOutlined,
  FolderOutlined,
  FileOutlined,
  SearchOutlined,
  CopyOutlined,
  SettingOutlined,
  DownloadOutlined,
  UploadOutlined
} from '@ant-design/icons';
import { DeleteOutlined } from '@ant-design/icons/lib';
import Color from '../../common/model/base/option/Color';
import SafeUtil from '../../common/util/SafeUtil';
import Moon from '../../common/model/global/Moon';
import InputSize from '../widget/form/InputSize';
import DateUtil from '../../common/util/DateUtil';

// 定义部门节点接口
interface DeptNode {
  value: string;
  title: string;
  key: string;
  rawData: {
    id: string;
    name: string;
    shortName?: string;
    parentId?: string;
    children?: DeptNode[];
  };
  children?: DeptNode[];
}

// 定义批量创建结果的接口
interface BatchCreateResult {
  deptId: string;
  deptName: string;
  success: boolean;
  alreadyExists?: boolean;
  spaceUuid?: string;
  spaceName?: string;
  errorMessage?: string;
  membersAdded?: number;
  membersSkipped?: number;
}

// 定义批量创建响应数据的接口
interface BatchCreateResponse {
  code?: string;
  Code?: string;
  successCount: number;
  alreadyExistsCount?: number;
  failedCount: number;
  results?: Array<{
    deptId: string;
    deptName: string;
    success: boolean;
    spaceUuid?: string;
    spaceName?: string;
    errorMessage?: string;
    membersAdded?: number;
    membersSkipped?: number;
  }>;
  message?: string;
  msg?: string;
}

// 定义处理后的批量创建结果接口
interface ProcessedBatchCreateResult extends BatchCreateResult {
  alreadyExists?: boolean;
}

interface IProps extends RouteComponentProps {}

interface IState {
  deptTreeData: DeptNode[];
  deptLoading: boolean;
  batchCreateModalVisible: boolean;
  selectedDeptIds: string[];
  spaceTemplate: {
    sizeLimit: number;
    totalSizeLimit: number;
  };
  batchCreateLoading: boolean;
  batchResults: {
    successCount: number;
    alreadyExistsCount: number;
    failedCount: number;
    results: ProcessedBatchCreateResult[];
  } | null;
  importModalVisible: boolean;
  importConfigText: string;
  importLoading: boolean;
  importResult: {
    totalCount: number;
    createdCount: number;
    skippedCount: number;
    memberAddedCount: number;
    memberSkippedCount: number;
    details: Array<{
      name: string;
      success: boolean;
      reason?: string;
      membersAdded?: number;
      memberErrors?: string[];
    }>;
  } | null;
  viewMode: 'card' | 'list';
  crossSearchVisible: boolean;
  crossSearchLoading: boolean;
  crossSearchKeyword: string;
}

export default class List extends HwzComponent<IProps, IState> {
  user = Moon.getSingleton().user;
  pager = new Pager<Space>(this, Space, Pager.MAX_PAGE_SIZE);
  crossPager = new Pager<Matter>(this, Matter, 20);
  
  modalState: {
    visible: boolean;
    mode: 'create' | 'edit';
    initialValues?: SpaceFormValues;
  } = {
    visible: false,
    mode: 'create',
  };

  constructor(props: IProps) {
    super(props);
    
    const GB = 1024 * 1024 * 1024;
    
    this.state = {
      deptTreeData: [],
      deptLoading: false,
      batchCreateModalVisible: false,
      selectedDeptIds: [],
      spaceTemplate: {
        sizeLimit: 1 * GB,
        totalSizeLimit: 10 * GB,
      },
      batchCreateLoading: false,
      batchResults: null,
      importModalVisible: false,
      importConfigText: '',
      importLoading: false,
      importResult: null,
      viewMode: 'card',
      crossSearchVisible: false,
      crossSearchLoading: false,
      crossSearchKeyword: '',
    };
  }

  componentDidMount() {
    this.pager.enableHistory();
    this.pager.setFilterValue('type', 'SHARED');
    this.pager.httpList();
    
    this.fetchDeptTreeData();
  }

  changePage(page: number) {
    this.pager.page = page - 1;
    this.pager.httpList();
    this.updateUI();
  }

  handleCreate() {
    this.modalState = {
      visible: true,
      mode: 'create',
    };
    this.updateUI();
  }

  handleOpenBatchCreateModal = () => {
    const GB = 1024 * 1024 * 1024;
    
    this.setState({
      batchCreateModalVisible: true,
      selectedDeptIds: [],
      spaceTemplate: {
        sizeLimit: 1 * GB,
        totalSizeLimit: 10 * GB,
      },
      batchResults: null
    });
  };

  handleCloseBatchCreateModal = () => {
    this.setState({
      batchCreateModalVisible: false,
      selectedDeptIds: [],
      batchCreateLoading: false,
      batchResults: null
    });
    
    this.pager.httpList();
  };

  handleExportConfig = () => {
    message.loading({ content: Lang.t('space.exporting'), key: 'spaceExport', duration: 0 });
    fetch('/api/space/export', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      credentials: 'include'
    })
      .then(response => response.json())
      .then(data => {
        message.destroy('spaceExport');
        if (!data || data.code !== 'OK' || !data.data) {
          message.error(data && data.msg ? data.msg : Lang.t('space.exportFailed'));
          return;
        }

        const jsonStr = JSON.stringify(data.data, null, 2);
        const blob = new Blob([jsonStr], { type: 'application/json' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const now = new Date();
        const pad = (n: number) => n.toString().padStart(2, '0');
        const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
        link.setAttribute('href', url);
        link.setAttribute('download', `space_config_${timestamp}.json`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 100);

        message.success(Lang.t('space.exportSuccess'));
      })
      .catch(() => {
        message.destroy('spaceExport');
        message.error(Lang.t('space.exportFailed'));
      });
  };

  handleOpenImportModal = () => {
    this.setState({
      importModalVisible: true,
      importConfigText: '',
      importLoading: false,
      importResult: null
    });
  };

  handleCloseImportModal = () => {
    this.setState({
      importModalVisible: false,
      importLoading: false,
      importResult: null,
      importConfigText: ''
    });

    this.pager.httpList();
  };

  handleImportFile = (file: File) => {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.setState({
        importConfigText: String((e && e.target && e.target.result) || ''),
        importResult: null
      });
    };
    reader.readAsText(file);
    return false;
  };

  handleImportConfig = () => {
    const { importConfigText } = this.state;
    const configStr = (importConfigText || '').trim();
    if (!configStr) {
      message.warning(Lang.t('space.importConfigEmpty'));
      return;
    }

    try {
      JSON.parse(configStr);
    } catch (err) {
      message.error(Lang.t('space.importConfigInvalid'));
      return;
    }

    Modal.confirm({
      title: Lang.t('space.importConfig'),
      icon: <ExclamationCircleFilled />,
      content: Lang.t('space.importConfirm'),
      okText: Lang.t('confirm'),
      cancelText: Lang.t('cancel'),
      onOk: () => {
        this.doImportConfig(configStr);
      },
    });
  };

  doImportConfig = (configStr: string) => {
    this.setState({ importLoading: true });
    fetch('/api/space/import', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: configStr
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ importLoading: false });
        if (!data || data.code !== 'OK') {
          message.error(data && data.msg ? data.msg : Lang.t('space.importFailed'));
          return;
        }
        this.setState({ importResult: data.data || null });
        message.success(Lang.t('space.importSuccess'));
        this.pager.httpList();
      })
      .catch(() => {
        this.setState({ importLoading: false });
        message.error(Lang.t('space.importFailed'));
      });
  };

  renderImportResult = (result: any) => {
    const details = result.details || [];
    return (
      <div style={{ marginTop: 16 }}>
        <Alert
          type="success"
          showIcon
          message={Lang.t('space.importResult', result.totalCount, result.createdCount, result.skippedCount, result.memberAddedCount)}
        />
        {details.length > 0 && (
          <div style={{ maxHeight: 240, overflowY: 'auto', marginTop: 8 }}>
            {details.map((d: any, index: number) => (
              <div key={index} style={{ marginBottom: 4, fontSize: 13 }}>
                <Tag color={d.success ? 'success' : 'error'}>
                  {d.success ? Lang.t('space.success') : Lang.t('space.failed')}
                </Tag>
                <span style={{ marginRight: 8 }}>{d.name || '-'}</span>
                {d.success && d.membersAdded > 0 && (
                  <span style={{ color: '#666' }}>
                    {Lang.t('space.membersAddedCount', d.membersAdded)}
                  </span>
                )}
                {!d.success && d.reason && (
                  <span style={{ color: '#999' }}>{d.reason}</span>
                )}
                {d.memberErrors && d.memberErrors.length > 0 && (
                  <span style={{ color: '#faad14' }}>{d.memberErrors.join('; ')}</span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  fetchDeptTreeData = () => {
    this.setState({ deptLoading: true });
    
    const requestBody = {
      page: 0,
      pageSize: 1000,
      orderIndex: 'ASC'
    };
    
    fetch('/api/sys/dept/page', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(requestBody)
    })
    .then(response => response.json())
    .then(data => {
      console.log('部门列表响应调试开始 ==========');
      console.log('原始响应:', data);
      
      const treeData = this.convertDataFromBackend(data);
      console.log('转换后的树数据:', treeData);
      
      const treeSelectData = this.convertToTreeSelectData(treeData);
      console.log('TreeSelect数据:', treeSelectData);
      
      this.setState({ 
        deptTreeData: treeSelectData,
        deptLoading: false 
      });
      
      this.checkDeptShortNames(treeSelectData);
    })
    .catch(error => {
      console.error('获取部门数据失败:', error);
      this.setState({ deptLoading: false });
    });
  };

  checkDeptShortNames = (nodes: DeptNode[]) => {
    console.log('检查部门简称 ==========');
    const checkNode = (node: DeptNode, depth: number) => {
      const indent = '  '.repeat(depth);
      console.log(`${indent}节点: ${node.rawData.name}, 简称: ${node.rawData.shortName || '(空)'}, ID: ${node.rawData.id}, 父ID: ${node.rawData.parentId}`);
      
      if (node.children && node.children.length > 0) {
        node.children.forEach(child => checkNode(child, depth + 1));
      }
    };
    
    nodes.forEach(node => checkNode(node, 0));
  };

  convertDataFromBackend = (rawData: any): any[] => {
    if (!rawData) return [];
    
    let records: any[] = [];
    
    console.log('开始转换数据，原始数据:', rawData);
    
    if (rawData.code === "OK" || rawData.code === "SUCCESS" || rawData.Code === "OK") {
      const dataField = rawData.data || rawData.Data;
      if (dataField) {
        if (dataField.records && Array.isArray(dataField.records)) {
          records = dataField.records;
          console.log('从records字段获取数据，数量:', records.length);
        } else if (Array.isArray(dataField)) {
          records = dataField;
          console.log('从数组字段获取数据，数量:', records.length);
        }
      }
    } else if (Array.isArray(rawData)) {
      records = rawData;
      console.log('直接是数组数据，数量:', records.length);
    }
    
    const processTreeData = (nodes: any[]): any[] => {
      return nodes.map(node => {
        const processedNode = { ...node };
        
        console.log('处理节点:', {
          id: node.id,
          name: node.name,
          shortName: node.shortName,
          parentId: node.parentId,
          hasChildren: node.children || node.Children
        });
        
        if (processedNode.Children && Array.isArray(processedNode.Children)) {
          processedNode.children = processTreeData(processedNode.Children);
          delete processedNode.Children;
        } else if (processedNode.children && Array.isArray(processedNode.children)) {
          processedNode.children = processTreeData(processedNode.children);
        }
        
        if (processedNode.id) {
          processedNode.key = processedNode.id.toString();
        }
        
        return processedNode;
      });
    };
    
    const result = processTreeData(records);
    console.log('处理后的树数据:', result);
    return result;
  };

  convertToTreeSelectData = (nodes: any[]): DeptNode[] => {
    if (!nodes || nodes.length === 0) return [];
    
    return nodes.map((node: any) => {
      const treeNode: DeptNode = {
        title: node.shortName || node.name || Lang.t('department.idFormat', `部门ID: {0}`, node.id),
        value: node.id ? node.id.toString() : '',
        key: node.id ? node.id.toString() : '',
        rawData: {
          id: node.id,
          name: node.name,
          shortName: node.shortName,
          parentId: node.parentId,
          children: []
        }
      };
      
      if (node.children && Array.isArray(node.children) && node.children.length > 0) {
        treeNode.children = this.convertToTreeSelectData(node.children);
      } else {
        treeNode.children = [];
      }
      
      return treeNode;
    });
  };

  findDeptById = (deptId: string): DeptNode | null => {
    const findInTree = (nodes: DeptNode[]): DeptNode | null => {
      for (const node of nodes) {
        console.log('查找部门节点:', node.value, '目标:', deptId);
        if (node.value === deptId) {
          console.log('找到部门:', node);
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = findInTree(node.children);
          if (found) {
            return found;
          }
        }
      }
      return null;
    };
    
    return findInTree(this.state.deptTreeData);
  };

  findDeptPathById = (deptId: string): DeptNode[] => {
    const findPath = (nodes: DeptNode[], path: DeptNode[] = []): DeptNode[] | null => {
      for (const node of nodes) {
        const currentPath = [...path, node];
        if (node.value === deptId) {
          console.log(`找到路径，节点深度: ${currentPath.length}`, currentPath.map(n => n.rawData.name));
          return currentPath;
        }
        if (node.children && node.children.length > 0) {
          const found = findPath(node.children, currentPath);
          if (found) {
            return found;
          }
        }
      }
      return null;
    };
    
    const path = findPath(this.state.deptTreeData) || [];
    console.log(`部门 ${deptId} 的完整路径:`, path.map(n => ({name: n.rawData.name, shortName: n.rawData.shortName})));
    return path;
  };

  isLeafNode = (deptId: string): boolean => {
    const dept = this.findDeptById(deptId);
    const isLeaf = !!(dept && (!dept.children || dept.children.length === 0));
    console.log(`部门 ${deptId} 是否是叶子节点: ${isLeaf}`, dept);
    return isLeaf;
  };

  generateSpaceName = (deptId: string): string => {
    console.log(`为部门 ${deptId} 生成空间名称`);
    
    const dept = this.findDeptById(deptId);
    if (!dept) {
      console.log(`未找到部门 ${deptId}`);
      return '';
    }
    
    const isLeaf = this.isLeafNode(deptId);
    const path = this.findDeptPathById(deptId);
    
    console.log('部门信息:', {
      id: deptId,
      name: dept.rawData.name,
      shortName: dept.rawData.shortName,
      isLeaf: isLeaf,
      pathLength: path.length,
      pathNames: path.map(p => p.rawData.name)
    });
    
    if (isLeaf && path.length > 1) {
      const parentDept = path[path.length - 2];
      const currentDept = path[path.length - 1];
      
      let parentShortName = parentDept.rawData.shortName || 
                          (parentDept.rawData.name && parentDept.rawData.name.substring(0, 2)) || '';
      let currentShortName = currentDept.rawData.shortName || 
                           (currentDept.rawData.name && currentDept.rawData.name.substring(0, 2)) || '';
      
      console.log('叶子节点命名:', {
        parentName: parentDept.rawData.name,
        parentShortName: parentShortName,
        currentName: currentDept.rawData.name,
        currentShortName: currentShortName,
        result: parentShortName + currentShortName
      });
      
      return parentShortName + currentShortName;
    } else {
      let shortName = dept.rawData.shortName || 
                     (dept.rawData.name && dept.rawData.name.substring(0, 2)) || '';
      
      console.log('非叶子节点命名:', {
        name: dept.rawData.name,
        shortName: shortName,
        isLeaf: isLeaf,
        pathLength: path.length
      });
      
      return shortName;
    }
  };

  handleBatchCreateSpaces = () => {
    const { selectedDeptIds } = this.state;
    
    if (selectedDeptIds.length === 0) {
      message.warning(Lang.t('space.selectDeptForBatchCreate', '请选择要创建空间的部门'));
      return;
    }

    const deptNames: string[] = selectedDeptIds.map(deptId => {
      const dept = this.findDeptById(deptId);
      const deptName = dept ? (dept.rawData?.name || dept.title) : Lang.t('department.idFormat', '部门ID: {0}', deptId);
      const spaceName = this.generateSpaceName(deptId);
      return `${deptName} → ${spaceName}`;
    });

    console.log('批量创建预览:', deptNames);

    const displayNames = deptNames.length > 3 
      ? [...deptNames.slice(0, 3), `...等${selectedDeptIds.length}个部门`]
      : deptNames;

    Modal.confirm({
      title: Lang.t('space.batchCreateConfirm', '批量创建空间确认'),
      icon: <ExclamationCircleFilled />,
      content: (
        <div>
          <p>{Lang.t('space.batchCreateDeptCount', '将为选中的 {0} 个部门批量创建空间：', selectedDeptIds.length)}</p>
          <ul style={{ paddingLeft: 20, marginBottom: 10 }}>
            {displayNames.map((name: string, index: number) => (
              <li key={index}>{name}</li>
            ))}
          </ul>
          
          <Alert
            type="info"
            message="空间命名规则"
            description={
              <div>
                <p>1. 如果选择叶子节点：空间名称 = 父节点简称 + 叶子节点简称</p>
                <p>2. 如果选择非叶子节点：空间名称 = 节点简称</p>
              </div>
            }
            style={{ marginTop: 10, marginBottom: 10 }}
            showIcon
          />
        </div>
      ),
      okText: Lang.t('space.startBatchCreate', '开始批量创建'),
      cancelText: Lang.t('cancel', '取消'),
      onOk: () => {
        this.executeBatchCreateSpaces();
      },
    });
  };

  getHumanizeSize = (bytes: number): string => {
    if (bytes <= 0) return Lang.t('user.noLimit', '未限制');
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
    if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
  };

  executeBatchCreateSpaces = () => {
    const { selectedDeptIds, spaceTemplate } = this.state;
    
    this.setState({ batchCreateLoading: true, batchResults: null });
    
    console.log('========== 开始批量创建空间 ==========');
    console.log('选中的部门ID:', selectedDeptIds);
    
    const requestData = {
      deptIds: selectedDeptIds,
      spaceTemplate: {
        sizeLimit: spaceTemplate.sizeLimit,
        totalSizeLimit: spaceTemplate.totalSizeLimit,
        type: 'SHARED'
      },
      memberRole: 'READ_WRITE'
    };
    
    console.log('批量创建请求数据:', JSON.stringify(requestData, null, 2));
    
    fetch('/api/space/batchCreateByDept', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(requestData)
    })
    .then(response => {
      console.log('响应状态:', response.status, response.statusText);
      return response.json();
    })
    .then(data => {
      console.log('批量创建空间响应:', data);
      
      const response = data as BatchCreateResponse;
      
      if (response && (response.code === 'OK' || response.Code === 'OK' || response.successCount !== undefined)) {
        const results = response.results || [];
        
        let alreadyExistsCount = 0;
        if (response.alreadyExistsCount !== undefined) {
          alreadyExistsCount = response.alreadyExistsCount;
        } else {
          alreadyExistsCount = results.filter((result: any) => 
            !result.success && 
            result.errorMessage && 
            (result.errorMessage.includes('已有对应的空间') || 
             result.errorMessage.includes('已有对应空间'))
          ).length;
        }
        
        const processedResults: ProcessedBatchCreateResult[] = results.map((result: any) => {
          const alreadyExists = !result.success && 
                               result.errorMessage && 
                               (result.errorMessage.includes('已有对应的空间') || 
                                result.errorMessage.includes('已有对应空间'));
          
          return {
            ...result,
            alreadyExists: alreadyExists ? true : undefined
          };
        });
        
        const batchResults = {
          successCount: response.successCount || 0,
          alreadyExistsCount: alreadyExistsCount,
          failedCount: response.failedCount || 0,
          results: processedResults
        };
        
        console.log('处理后的批量结果:', batchResults);
        
        this.setState({
          batchCreateLoading: false,
          batchResults: batchResults
        });
        
        console.log('刷新空间列表...');
        this.pager.httpList(() => {
          console.log('空间列表刷新完成');
          
          const totalSuccess = batchResults.successCount + batchResults.alreadyExistsCount;
          
          if (batchResults.failedCount === 0) {
            if (batchResults.alreadyExistsCount === 0) {
              message.success(Lang.t('space.spaceBatchCreateSuccess', '批量创建空间成功'));
            } else if (batchResults.successCount === 0) {
              message.info(Lang.t('space.allDeptsHaveSpace', '所选部门已存在对应空间，无需重复创建'));
            } else {
              message.success(
                Lang.t('space.batchCreateWithExists', 
                       '批量创建完成，成功创建 {0} 个空间，{1} 个部门已有空间', 
                       batchResults.successCount, 
                       batchResults.alreadyExistsCount)
              );
            }
          } else {
            if (batchResults.successCount === 0 && batchResults.alreadyExistsCount === 0) {
              message.error(Lang.t('space.batchCreateAllFailed', '批量创建空间全部失败'));
            } else {
              message.warning(
                Lang.t('space.batchCreatePartialSuccess', 
                       '批量创建空间部分成功，成功创建 {0} 个，{1} 个已存在，{2} 个失败', 
                       batchResults.successCount, 
                       batchResults.alreadyExistsCount,
                       batchResults.failedCount)
              );
            }
          }
        });
      } else {
        console.error('批量创建返回错误:', data);
        this.setState({ batchCreateLoading: false });
        
        this.pager.httpList(() => {
          MessageBoxUtil.error(
            Lang.t('space.batchCreateError', 
                   '批量创建空间失败: {0}', 
                   response?.message || response?.msg || '未知错误')
          );
        });
      }
    })
    .catch(error => {
      console.error('批量创建空间失败:', error);
      this.setState({ batchCreateLoading: false });
      
      this.pager.httpList(() => {
        MessageBoxUtil.error(
          Lang.t('space.batchCreateError', 
                 '批量创建空间时发生网络错误: {0}', 
                 error.message)
        );
      });
    });
  };

  handleSizeLimitChange = (value: number | null) => {
    if (value !== null) {
      console.log('单文件限制改变为:', value);
      this.setState({
        spaceTemplate: {
          ...this.state.spaceTemplate,
          sizeLimit: value
        }
      });
    }
  };

  handleTotalSizeLimitChange = (value: number | null) => {
    if (value !== null) {
      console.log('空间大小限制改变为:', value);
      this.setState({
        spaceTemplate: {
          ...this.state.spaceTemplate,
          totalSizeLimit: value
        }
      });
    }
  };

  handleEdit(space: Space) {
    this.modalState = {
      visible: true,
      mode: 'edit',
      initialValues: space.getForm(),
    };
    this.updateUI();
  }

  handleConfirmModalForm(values: SpaceFormValues) {
    const space = new Space();
    space.assign(values);
    console.log('保存空间配置:', {
      sizeLimit: values.sizeLimit,
      totalSizeLimit: values.totalSizeLimit
    });
    space.httpSave(
      () => {
        MessageBoxUtil.success(Lang.t('operationSuccess'));
        this.pager.httpList();
      },
      null,
      () => this.handleHideModalForm()
    );
  }

  handleHideModalForm() {
    this.modalState = {
      ...this.modalState,
      visible: false,
    };
    this.updateUI();
  }

  handleDelete(space: Space) {
    Modal.confirm({
      title: Lang.t('space.deleteHint'),
      icon: <ExclamationCircleFilled twoToneColor={Color.WARNING} />,
      cancelText: Lang.t('cancel'),
      okText: Lang.t('confirm'),
      onOk: () => {
        space.httpDel(() => {
          MessageBoxUtil.success(Lang.t('operationSuccess'));
          this.pager.httpList();
        });
      },
    });
  }
  
  handleSpaceMember(space: Space) {
    this.props.history.push(`/space/${space.uuid}/member`);
  }

  handleSpaceMatterList(space: Space) {
    this.props.history.push(`/space/${space.uuid}/matter/list`);
  }

  handleListAction(key: string, space: Space) {
    if (key === 'member') {
      this.handleSpaceMember(space);
    } else if (key === 'edit') {
      this.handleEdit(space);
    } else if (key === 'delete') {
      this.handleDelete(space);
    }
  }

  // 跨组检索：跨当前用户已加入的所有共享分组检索文件
  handleCrossGroupSearch = (value: string) => {
    const keyword = (value || '').trim();
    if (!keyword) {
      message.warning(Lang.t('space.crossGroupKeywordEmpty'));
      return;
    }
    this.crossPager.setFilterValue('crossGroup', 'true');
    this.crossPager.setFilterValue('name', keyword);
    this.crossPager.setFilterValue('puuid', Matter.MATTER_ROOT);
    this.crossPager.setFilterValue('deleted', false);
    this.crossPager.setFilterValue('checkContent', undefined);
    this.crossPager.setFilterValue('spaceUuid', undefined);
    this.crossPager.setFilterValue('approval', 0);
    this.crossPager.setFilterValue('outsendStatus', 0);
    this.crossPager.page = 0;
    this.setState({
      crossSearchVisible: true,
      crossSearchLoading: true,
      crossSearchKeyword: keyword,
    });
    this.crossPager.httpList(
      () => this.setState({ crossSearchLoading: false }),
      (error: any) => {
        this.setState({ crossSearchLoading: false });
        console.error('跨组检索失败:', error);
        message.error(Lang.t('space.crossGroupSearchFailed'));
      }
    );
  };

  changeCrossSearchPage = (page: number) => {
    this.crossPager.page = page - 1;
    this.crossPager.httpList(() => this.updateUI());
  };

  closeCrossSearchModal = () => {
    this.setState({ crossSearchVisible: false });
  };

  getCrossSearchSpaceName(matter: Matter): string {
    if (!matter.spaceUuid) return Lang.t('space.unknown');
    const space = this.pager.data.find((s) => s.uuid === matter.spaceUuid);
    if (space && space.name) return space.name;
    const spaceName = (matter as any).space_name;
    if (spaceName) return spaceName;
    return matter.spaceUuid;
  }

  handleCrossSearchResultClick(matter: Matter) {
    if (!matter.spaceUuid) return;
    if (matter.dir) {
      this.props.history.push(`/space/${matter.spaceUuid}/matter/list`);
    } else {
      this.props.history.push(`/space/${matter.spaceUuid}/matter/detail/${matter.uuid}`);
    }
  }

  renderCrossSearchModal = () => {
    const { crossSearchVisible, crossSearchLoading, crossSearchKeyword } = this.state;
    const columns: any[] = [
      {
        title: Lang.t('space.name'),
        dataIndex: 'name',
        key: 'name',
        render: (text: string, matter: Matter) => (
          <span title={text || ''}>
            {matter.dir ? (
              <FolderOutlined style={{ color: '#faad14', marginRight: 8 }} />
            ) : (
              <FileOutlined style={{ color: '#1890ff', marginRight: 8 }} />
            )}
            {text}
          </span>
        ),
      },
      {
        title: Lang.t('space.crossSearchGroupName'),
        dataIndex: 'spaceUuid',
        key: 'spaceUuid',
        width: 200,
        render: (spaceUuid: string, matter: Matter) => (
          <span>{this.getCrossSearchSpaceName(matter)}</span>
        ),
      },
      {
        title: Lang.t('space.crossSearchSize'),
        dataIndex: 'size',
        key: 'size',
        width: 120,
        render: (size: number, matter: Matter) =>
          matter.dir ? Lang.t('space.crossSearchDirectory') : this.getHumanizeSize(size || 0),
      },
      {
        title: Lang.t('matter.updateTime'),
        dataIndex: 'updateTime',
        key: 'updateTime',
        width: 160,
        render: (text: Date) => DateUtil.simpleDateHourMinute(text),
      },
    ];

    return (
      <Modal
        title={
          <span>
            <SearchOutlined />{' '}
            {Lang.t('space.crossGroupSearchTitle', crossSearchKeyword)}
          </span>
        }
        visible={crossSearchVisible}
        onCancel={this.closeCrossSearchModal}
        width={900}
        footer={null}
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 12 }}
          message={Lang.t('space.crossGroupScopeHint')}
        />
        <Table
          rowKey="uuid"
          size="small"
          loading={crossSearchLoading}
          columns={columns}
          dataSource={this.crossPager.data}
          pagination={false}
          locale={{
            emptyText: crossSearchLoading
              ? Lang.t('space.crossGroupLoading')
              : Lang.t('space.crossGroupEmpty'),
          }}
          onRow={(matter: Matter) => ({
            onClick: () => this.handleCrossSearchResultClick(matter),
            style: { cursor: 'pointer' },
          })}
        />
        {this.crossPager.totalItems > this.crossPager.pageSize && (
          <Pagination
            className="pull-right mt10"
            onChange={this.changeCrossSearchPage}
            current={this.crossPager.page + 1}
            total={this.crossPager.totalItems}
            pageSize={this.crossPager.pageSize}
            hideOnSinglePage
          />
        )}
      </Modal>
    );
  };

  renderListView = () => {
    const columns: any[] = [
      {
        title: Lang.t('space.name'),
        dataIndex: 'name',
        key: 'name',
        width: 200,
        sorter: (a: Space, b: Space) => (a.name || '').localeCompare(b.name || ''),
        render: (text: string, space: Space) => (
          <span
            className="space-list-name"
            title={space.name || ''}
            onClick={() => this.handleSpaceMatterList(space)}
          >
            {space.name}
          </span>
        ),
      },
      {
        title: Lang.t('space.sizeLimit'),
        dataIndex: 'sizeLimit',
        key: 'sizeLimit',
        width: 160,
        render: (text: number, space: Space) =>
          space.sizeLimit === -1 || space.sizeLimit === 0
            ? Lang.t('user.noLimit', '未限制')
            : this.getHumanizeSize(space.sizeLimit || 0),
      },
      {
        title: Lang.t('space.totalSizeLimit'),
        dataIndex: 'totalSizeLimit',
        key: 'totalSizeLimit',
        width: 160,
        render: (text: number, space: Space) =>
          space.totalSizeLimit === -1 || space.totalSizeLimit === 0
            ? Lang.t('user.noLimit', '未限制')
            : this.getHumanizeSize(space.totalSizeLimit || 0),
      },
      {
        title: Lang.t('space.totalSize'),
        dataIndex: 'totalSize',
        key: 'totalSize',
        width: 260,
        render: (text: number, space: Space) => (
          <div className="space-list-percent">
            <span className="space-list-percent-text">
              {space.getHumanizeTotalSize()} /{' '}
              {space.totalSizeLimit === -1 || space.totalSizeLimit === 0
                ? Lang.t('user.noLimit', '未限制')
                : this.getHumanizeSize(space.totalSizeLimit || 0)}
            </span>
            <Progress percent={Math.round(space.getUsedPercent())} />
          </div>
        ),
      },
      {
        title: '',
        key: 'action',
        width: 60,
        align: 'center' as 'center',
        render: (text: any, space: Space) => (
          <Dropdown
            overlay={
              <Menu onClick={(info: any) => this.handleListAction(info.key, space)}>
                <Menu.Item key="member">
                  <TeamOutlined /> {Lang.t('space.bindMember')}
                </Menu.Item>
                {this.user.isAdmin() && (
                  <>
                    <Menu.Item key="edit">
                      <EditOutlined /> {Lang.t('space.editGroup')}
                    </Menu.Item>
                    <Menu.Item key="delete">
                      <DeleteOutlined /> {Lang.t('common.delete')}
                    </Menu.Item>
                  </>
                )}
              </Menu>
            }
            trigger={['click']}
            placement="bottomRight"
          >
            <a
              className="space-list-more"
              onClick={(e) => e.preventDefault()}
            >
              <MoreOutlined />
            </a>
          </Dropdown>
        ),
      },
    ];

    return (
      <Table
        className="space-list-view"
        rowKey="uuid"
        size="small"
        columns={columns}
        dataSource={this.pager.data}
        pagination={false}
        locale={{ emptyText: <Empty description={Lang.t('space.emptyHint')} /> }}
      />
    );
  };

  renderBatchCreateResults = () => {
    const { batchResults, selectedDeptIds } = this.state;
    
    if (!batchResults) return null;
    
    const results = batchResults.results || [];
    
    let overallStatus = '';
    let overallColor = '';
    
    if (batchResults.failedCount === 0) {
      if (batchResults.alreadyExistsCount === 0) {
        overallStatus = '全部成功';
        overallColor = 'success';
      } else if (batchResults.successCount === 0) {
        overallStatus = '全部已存在';
        overallColor = 'blue';
      } else {
        overallStatus = '部分成功';
        overallColor = 'warning';
      }
    } else {
      if (batchResults.successCount === 0 && batchResults.alreadyExistsCount === 0) {
        overallStatus = '全部失败';
        overallColor = 'error';
      } else {
        overallStatus = '部分成功';
        overallColor = 'warning';
      }
    }
    
    return (
      <div style={{ marginTop: 20 }}>
        <Card 
          title={
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span>{Lang.t('space.batchCreateResults', '批量创建结果')}</span>
              <div>
                <Tag color={overallColor}>{overallStatus}</Tag>
              </div>
            </div>
          }
          size="small"
        >
          <div style={{ marginBottom: 16 }}>
            {batchResults.successCount > 0 && (
              <Badge 
                count={batchResults.successCount} 
                style={{ backgroundColor: '#52c41a', marginRight: 8 }}
              >
                <Tag color="success">{Lang.t('space.successCount', '成功')}</Tag>
              </Badge>
            )}
            {batchResults.alreadyExistsCount > 0 && (
              <Badge 
                count={batchResults.alreadyExistsCount} 
                style={{ backgroundColor: '#1890ff', marginRight: 8 }}
              >
                <Tag color="blue">{Lang.t('space.alreadyExistsCount', '已存在')}</Tag>
              </Badge>
            )}
            {batchResults.failedCount > 0 && (
              <Badge 
                count={batchResults.failedCount} 
                style={{ backgroundColor: '#ff4d4f' }}
              >
                <Tag color="error">{Lang.t('space.failedCount', '失败')}</Tag>
              </Badge>
            )}
          </div>
          
          {results.length > 0 && (
            <div style={{ maxHeight: 300, overflowY: 'auto' }}>
              {results.map((result: ProcessedBatchCreateResult, index: number) => (
                <Card 
                  key={index} 
                  size="small" 
                  style={{ 
                    marginBottom: 8,
                    borderLeft: `4px solid ${
                      result.success ? '#52c41a' : 
                      result.alreadyExists ? '#1890ff' : 
                      '#ff4d4f'
                    }`
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                        <strong style={{ fontSize: 14 }}>{result.deptName}</strong>
                        {result.spaceName && (
                          <span style={{ marginLeft: 8, fontSize: 12, color: '#666' }}>
                            → <strong style={{ color: '#1890ff' }}>{result.spaceName}</strong>
                          </span>
                        )}
                      </div>
                      
                      {result.success ? (
                        <div>
                          <Tag color="success" style={{ marginRight: 8 }}>
                            ✓ {Lang.t('space.createdSuccess', '创建成功')}
                          </Tag>
                          {(result.membersAdded ?? 0) > 0 && (
                            <span style={{ fontSize: 12, color: '#666', marginRight: 8 }}>
                              {Lang.t('space.membersAdded', '添加 {0} 名成员', result.membersAdded ?? 0)}
                            </span>
                          )}
                        </div>
                      ) : result.alreadyExists ? (
                        <div>
                          <Tag color="blue" style={{ marginRight: 8 }}>
                            ⓘ {Lang.t('space.alreadyExists', '已存在')}
                          </Tag>
                          {result.errorMessage && (
                            <span style={{ fontSize: 12, color: '#1890ff' }}>
                              {result.errorMessage}
                            </span>
                          )}
                        </div>
                      ) : (
                        <div>
                          <Tag color="error" style={{ marginRight: 8 }}>
                            ✗ {Lang.t('space.failed', '失败')}
                          </Tag>
                          {result.errorMessage && (
                            <span style={{ fontSize: 12, color: '#ff4d4f' }}>
                              {result.errorMessage}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          )}
          
          <div style={{ marginTop: 16, textAlign: 'center' }}>
            <Button 
              type="primary" 
              onClick={() => {
                this.pager.httpList(() => {
                  console.log('手动刷新空间列表完成');
                  this.handleCloseBatchCreateModal();
                });
              }}
              style={{ marginRight: 8 }}
            >
              {Lang.t('space.refreshAndClose', '刷新并关闭')}
            </Button>
            <Button 
              onClick={this.handleCloseBatchCreateModal}
            >
              {Lang.t('close', '关闭')}
            </Button>
          </div>
        </Card>
      </div>
    );
  };

  render() {
    const { pager, modalState } = this;
    const {
      deptTreeData,
      deptLoading,
      selectedDeptIds,
      batchCreateModalVisible,
      spaceTemplate,
      batchCreateLoading,
      batchResults,
      importModalVisible,
      importConfigText,
      importLoading,
      importResult,
      viewMode
    } = this.state;

    return (
      <div className="page-space-list">
        <HwzTitle name={Lang.t('space.name')}>
          <AntdSpace>
            <Input.Search
              placeholder={Lang.t('space.crossGroupSearchPlaceholder')}
              onSearch={this.handleCrossGroupSearch}
              enterButton={Lang.t('space.crossGroupSearch')}
              allowClear
              style={{ width: 320 }}
            />
            <Button
              type={viewMode === 'card' ? 'primary' : 'default'}
              icon={<AppstoreOutlined />}
              title={Lang.t('space.viewCard')}
              onClick={() => this.setState({ viewMode: 'card' })}
            />
            <Button
              type={viewMode === 'list' ? 'primary' : 'default'}
              icon={<BarsOutlined />}
              title={Lang.t('space.viewList')}
              onClick={() => this.setState({ viewMode: 'list' })}
            />
            {this.user.isAdmin() && (
              <>
                <Button type="primary" onClick={() => this.handleCreate()}>
                  {Lang.t('space.create')}
                </Button>
                <Button 
                  type="primary" 
                  icon={<UsergroupAddOutlined />}
                  onClick={this.handleOpenBatchCreateModal}
                >
                  {Lang.t('space.batchCreate')}
                </Button>
                <Button
                  icon={<DownloadOutlined />}
                  onClick={this.handleExportConfig}
                >
                  {Lang.t('space.exportConfig')}
                </Button>
                <Button
                  icon={<UploadOutlined />}
                  onClick={this.handleOpenImportModal}
                >
                  {Lang.t('space.importConfig')}
                </Button>
              </>
            )}
          </AntdSpace>
        </HwzTitle>

        {viewMode === 'card' ? (
          <Row gutter={[10, 10]}>
            {pager.data.map((space) => {
              console.log('空间详情:', {
                name: space.name,
                sizeLimit: space.sizeLimit,
                totalSizeLimit: space.totalSizeLimit,
                getHumanizeSizeLimit: space.getHumanizeSizeLimit ? space.getHumanizeSizeLimit() : '方法不存在'
              });

              return (
                <Col xs={24} sm={24} md={12} lg={8} key={space.uuid}>
                  <Card
                    className="space-item"
                    size="small"
                    onClick={() => this.handleSpaceMatterList(space)}
                  >
                    <div className="space-item-name-wrapper mb10">
                      <div
                        className="space-item-name one-line"
                        title={space.name!}
                      >
                        {space.name}
                      </div>
                      <AntdSpace className="space-item-icons">
                        <TeamOutlined
                          className="btn-action btn-member"
                          onClick={(e) =>
                            SafeUtil.stopPropagationWrap(e)(
                              this.handleSpaceMember(space)
                            )
                          }
                        />
                        {this.user.isAdmin() && (
                          <>
                            <EditOutlined
                              className="btn-action btn-edit"
                              onClick={(e) =>
                                SafeUtil.stopPropagationWrap(e)(
                                  this.handleEdit(space)
                                )
                              }
                            />
                            <DeleteOutlined
                              className="btn-action btn-del"
                              onClick={(e) =>
                                SafeUtil.stopPropagationWrap(e)(
                                  this.handleDelete(space)
                                )
                              }
                            />
                          </>
                        )}
                      </AntdSpace>
                    </div>
                    <div className="space-item-percent">
                      <div>
                        {Lang.t('space.sizeLimit')}：
                        {space.sizeLimit === -1 || space.sizeLimit === 0 ?
                          Lang.t('user.noLimit', '未限制') :
                          this.getHumanizeSize(space.sizeLimit || 0)}
                      </div>
                      <div>
                        {Lang.t('space.totalSizeLimit')}：
                        {space.totalSizeLimit === -1 || space.totalSizeLimit === 0 ?
                          Lang.t('user.noLimit', '未限制') :
                          this.getHumanizeSize(space.totalSizeLimit || 0)}
                      </div>
                      <div>
                        {space.getHumanizeTotalSize()} /{' '}
                        {space.totalSizeLimit === -1 || space.totalSizeLimit === 0 ?
                          Lang.t('user.noLimit', '未限制') :
                          this.getHumanizeSize(space.totalSizeLimit || 0)}
                      </div>
                      <Progress percent={Math.round(space.getUsedPercent())} />
                    </div>
                  </Card>
                </Col>
              );
            })}
          </Row>
        ) : (
          this.renderListView()
        )}
        <Pagination
          className="space-pagination pull-right"
          onChange={this.changePage.bind(this)}
          current={pager.page + 1}
          total={pager.totalItems}
          pageSize={pager.pageSize}
          hideOnSinglePage
        />

        {viewMode === 'card' && pager.isEmpty() && <Empty description={Lang.t('space.emptyHint')} />}

        {modalState.visible && (
          <ModalForm
            mode={modalState.mode}
            initialValues={modalState.initialValues}
            onOk={this.handleConfirmModalForm.bind(this)}
            onCancel={() => this.handleHideModalForm()}
          />
        )}

        <Modal
          title={
            <span>
              <UsergroupAddOutlined /> {Lang.t('space.batchCreateTitle', '批量创建空间')}
            </span>
          }
          visible={batchCreateModalVisible}
          onCancel={this.handleCloseBatchCreateModal}
          width={800}
          footer={[
            <Button 
              key="cancel" 
              onClick={this.handleCloseBatchCreateModal}
            >
              {Lang.t('cancel')}
            </Button>,
            <Button 
              key="submit" 
              type="primary" 
              loading={batchCreateLoading}
              onClick={this.handleBatchCreateSpaces}
              icon={<FolderAddOutlined />}
            >
              {Lang.t('space.startBatchCreate', '开始批量创建')}
            </Button>
          ]}
        >
          <div>
            <div style={{ marginBottom: 24 }}>
              <h4 style={{ marginBottom: 8 }}>
                <ApartmentOutlined /> {Lang.t('space.selectDepartments', '选择部门')}
              </h4>
              <TreeSelect
                treeData={deptTreeData}
                value={selectedDeptIds}
                onChange={(value: string[]) => {
                  console.log('TreeSelect onChange:', value);
                  value.forEach(deptId => {
                    const dept = this.findDeptById(deptId);
                    console.log(`选中的部门 ${deptId}:`, dept?.rawData.name, '叶子节点:', this.isLeafNode(deptId));
                  });
                  this.setState({ selectedDeptIds: value });
                }}
                treeCheckable={true}
                showCheckedStrategy={TreeSelect.SHOW_CHILD}
                placeholder={Lang.t('space.selectDeptHint', '选择要创建空间的部门（可多选）')}
                style={{ width: '100%' }}
                loading={deptLoading}
                treeDefaultExpandAll
                showSearch
                treeNodeFilterProp="title"
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <h4 style={{ marginBottom: 8 }}>
                <SettingOutlined /> {Lang.t('space.spaceConfigTemplate', '空间配置')}
              </h4>
              <Row gutter={16}>
                <Col span={12}>
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ display: 'block', marginBottom: 4 }}>
                      {Lang.t('space.sizeLimit', '单文件限制')}：
                    </label>
                    <InputSize
                      className="w100 wide-input-size" 
                      value={spaceTemplate.sizeLimit}
                      onChange={this.handleSizeLimitChange}
                      placeholder={Lang.t('space.sizeLimitTip', '请输入单文件限制')}
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ display: 'block', marginBottom: 4 }}>
                      {Lang.t('space.totalSizeLimit', '空间大小限制')}：
                    </label>
                    <InputSize
                      className="w100 wide-input-size"  
                      value={spaceTemplate.totalSizeLimit}
                      onChange={this.handleTotalSizeLimitChange}
                      placeholder={Lang.t('space.totalSizeLimitTip', '请输入空间大小限制')}
                    />
                  </div>
                </Col>
              </Row>
            </div>

            {selectedDeptIds.length > 0 && (
              <div style={{ padding: 12, backgroundColor: '#f6ffed', borderRadius: 4, marginBottom: 16 }}>
                <p style={{ marginBottom: 8, fontWeight: 'bold' }}>
                  <CopyOutlined /> {Lang.t('space.batchCreatePreview', '批量创建预览')}
                </p>
                <p>
                  {Lang.t('space.willCreateSpacesForDepts', '将为以下部门创建空间：')}
                </p>
                <ul style={{ paddingLeft: 20, marginBottom: 0, maxHeight: 200, overflowY: 'auto' }}>
                  {selectedDeptIds.map((deptId: string, index: number) => {
                    const dept = this.findDeptById(deptId);
                    const deptName = dept ? (dept.rawData?.name || dept.title) : `部门ID: ${deptId}`;
                    const spaceName = this.generateSpaceName(deptId);
                    const isLeaf = this.isLeafNode(deptId);
                    const path = this.findDeptPathById(deptId);
                    
                    return (
                      <li key={index} style={{ marginBottom: 4 }}>
                        <div>
                          <strong>{deptName}</strong> 
                          <span style={{ fontSize: 12, color: '#666', marginLeft: 4 }}>
                            ({isLeaf ? 
                              Lang.t('space.leafNode', '叶子节点') : 
                              Lang.t('space.nonLeafNode', '非叶子节点')})
                          </span>
                        </div>
                        <div style={{ marginLeft: 20, fontSize: 14 }}>
                          → <strong>{spaceName}</strong>
                        </div>
                        <div style={{ marginLeft: 20, fontSize: 12, color: '#999' }}>
                          {Lang.t('space.pathLabel', '路径')}: {path.map(p => p.rawData.name).join(' → ')}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            {batchResults && this.renderBatchCreateResults()}
          </div>
        </Modal>

        <Modal
          title={
            <span>
              <UploadOutlined /> {Lang.t('space.importConfig')}
            </span>
          }
          visible={importModalVisible}
          onCancel={this.handleCloseImportModal}
          width={720}
          footer={[
            <Button
              key="cancel"
              onClick={this.handleCloseImportModal}
              disabled={importLoading}
            >
              {Lang.t('cancel')}
            </Button>,
            <Button
              key="import"
              type="primary"
              icon={<UploadOutlined />}
              loading={importLoading}
              disabled={!importConfigText.trim()}
              onClick={this.handleImportConfig}
            >
              {Lang.t('space.importConfig')}
            </Button>
          ]}
        >
          <div>
            <Alert
              message={Lang.t('space.importConfirm')}
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
            />
            <div style={{ marginBottom: 12 }}>
              <Upload
                accept=".json,.txt,application/json"
                showUploadList={false}
                beforeUpload={(file) => this.handleImportFile(file)}
                disabled={importLoading}
              >
                <Button icon={<UploadOutlined />} disabled={importLoading}>
                  {Lang.t('space.selectImportFile')}
                </Button>
              </Upload>
            </div>
            <Input.TextArea
              rows={14}
              value={importConfigText}
              onChange={(e) =>
                this.setState({ importConfigText: e.target.value, importResult: null })
              }
              placeholder={Lang.t('space.importConfigPlaceholder')}
              style={{ fontFamily: 'Consolas, Menlo, monospace' }}
            />
            {importResult && this.renderImportResult(importResult)}
          </div>
        </Modal>

        {this.renderCrossSearchModal()}
      </div>
    );
  }
}